
import { Options, Vue } from 'vue-class-component';
import { articlesService, Article } from '../services/articles.service';

@Options({})
export default class ManageArticlesView extends Vue {
    articles: Article[] = [];

    async mounted() {
        await this.loadArticles();
    }

    async loadArticles() {
        this.articles = await articlesService.getAllArticles();
    }

    async createArticle() {
        const id = await articlesService.createArticle();
        this.$router.push({ path: `/admin/articles/${id}` });
    }

    editArticle(article: Article) {
        this.$router.push({ path: `/admin/articles/${article.id}` });
    }

    async deleteArticle(article: Article) {
        if (confirm(`Delete "${article.title}"?`)) {
            await articlesService.deleteArticle(article.id);
            await this.loadArticles();
        }
    }

    getStatusColor(status: string) {
        switch (status) {
            case 'published': return 'success';
            case 'draft': return 'warning';
            case 'deleted': return 'error';
            default: return 'grey';
        }
    }

    formatDate(date: string) {
        if (!date) return '';
        return new Date(date).toLocaleDateString();
    }
}
